import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import { rejectError } from 'common/_redux';

import BasicModal from '../modals/BasicModal';
import DefaultButton from '../DefaultButton';

const getErrorDescription = errorMessage => {
  if (typeof errorMessage === 'string') {
    return errorMessage;
  }

  if (errorMessage && typeof errorMessage === 'object') {
    return errorMessage.response?.data?.detail || errorMessage.message || 'Something went wrong';
  }

  return 'Something went wrong';
};

const ErrorHandler = ({ children, rejectError, hasErrors, redirect, errorMessage }) => {
  const history = useHistory();
  const description = getErrorDescription(errorMessage);
  return (
    <>
      {children}
      <BasicModal
        onRequestClose={rejectError}
        isOpen={hasErrors}
        captionId={typeof errorMessage === 'string' ? 'commonErrorModalTitle' : 'somethingWentWrongCaption'}
        description={description}
        descriptionId="somethingWentWrongDescription"
        overlayClassName="Modal_error-overlay">
        <DefaultButton
          textId="justClose"
          onClick={() => {
            rejectError();
            if (redirect) {
              history.push(redirect);
            }
          }}
        />
      </BasicModal>
    </>
  );
};

ErrorHandler.propTypes = {
  hasErrors: PropTypes.bool.isRequired,
  rejectError: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  redirect: PropTypes.string,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

ErrorHandler.defaultProps = {
  redirect: null,
  errorMessage: '',
};

export default connect(({ common: { errorMessage, hasErrors, redirect } }) => ({ errorMessage, hasErrors, redirect }), {
  rejectError,
})(ErrorHandler);
export { ErrorHandler, getErrorDescription };
